<style scoped>
@import "./index.css";
</style>

<template>

    <div id="layout-container-hui">
        <Row class-name="tf-row">
            <Col :md="8" :xs="24">
                <Card id="myCard" :bordered="false" :dis-hover="true">
                    <div class="myCard-head" slot="title">
                        <span class="myCard-title">关于瀚土智能</span>
                    </div>
                    <div class="myCard-con web-gailan overview">
                        <img v-if="con.aboutUsImage" style="width: 100%" :src="imgSrc+con.aboutUsImage" alt="">
                        <div v-html="con.aboutUsContent"></div>
                    </div>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imgSrc:this.$func.imgSrc,
            con:''
        }
    },
    created() {
        const that = this;
        that.$func.ajax('aboutUs',
        {},function(r){
            if(!r.statusCode){
                that.$func.msg(r.message,'error');
            }else{
                that.con = r.type;
            }
        })
    },
    methods: {

    }
};
</script>
